"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3array = require("d3-array");
var Accessor_1 = require("./models/Accessor");
exports.measureDomainToRender = function (data, maxPrecision, accessors) {
    if (maxPrecision === void 0) { maxPrecision = 0.01; }
    if (accessors === void 0) { accessors = [Accessor_1.DefaultMeasureAccessor]; }
    var values = exports.collectValues(data, accessors);
    return exports.adjustMeasureDomain(d3array.extent(values), maxPrecision);
};
var MIN_PRECISION_FACTOR = 5;
/**
 * This function creates an adjusted domain for the measure axis.
 *
 * It follows a few heuristics:
 * - Don't cross the 0 line unless the data does
 * - Leave some space above/below the value furthest from zero (currently 10%)
 * - Aim for "the golden ratio" for space between the value closest to zero and the edge of the chart
 * - Ensure the domain is larger than the maximum precision the metric will display
 *
 * @param measureDomain the domain of the data
 * @param maxPrecision the maximum precision that will be rendered (defaults to 0.01)
 */
exports.adjustMeasureDomain = function (measureDomain, maxPrecision) {
    if (maxPrecision === void 0) { maxPrecision = 0.01; }
    if (measureDomain[0] === undefined) {
        return [0, 1];
    }
    var dataMin = measureDomain[0], dataMax = measureDomain[1];
    var measureDiff = Math.abs(dataMax - dataMin);
    var margin = measureDiff * 0.1;
    if (dataMin === dataMax) {
        if (dataMax === 0) {
            return [0, 1];
        }
        else if (dataMax > 0) {
            return [0, dataMax * 1.3];
        }
        else {
            return [dataMax * 1.3, 0];
        }
    }
    if (measureDiff < maxPrecision * MIN_PRECISION_FACTOR) {
        return [dataMin - maxPrecision * 2, dataMax + maxPrecision * 2];
    }
    if (dataMin < 0 && dataMax > 0) {
        return [dataMin - margin, dataMax + margin];
    }
    if (dataMin === 0) {
        return [dataMin, dataMax + margin];
    }
    if (dataMax === 0) {
        return [dataMin - margin, dataMax];
    }
    if (dataMin > 0) {
        var scaleMax = dataMax + margin;
        return [goldenRatioClampedToZero(dataMin, scaleMax), scaleMax];
    }
    else {
        var scaleFurthestFromZero = dataMin - margin;
        return [scaleFurthestFromZero, goldenRatioClampedToZero(dataMax, scaleFurthestFromZero)];
    }
};
var goldenRatioClampedToZero = function (closestToZero, scaleFurthestFromZero) {
    if (closestToZero === 0) {
        return 0;
    }
    // See https://www.chezvoila.com/blog/yaxis
    var idealValue = (3 * closestToZero - scaleFurthestFromZero) / 2;
    if ((closestToZero > 0 && idealValue < 0) || (closestToZero < 0 && idealValue > 0)) {
        // clamp to zero if the ideal value would cross the zero line
        return 0;
    }
    return idealValue;
};
exports.timeDomainToRender = function (data) {
    return d3array.extent(data, function (p) { return p.timestamp; });
};
exports.collectValues = function (data, accessors) {
    var values = [];
    data.forEach(function (d) {
        return accessors.forEach(function (a) {
            var _a;
            var value = (_a = a) === null || _a === void 0 ? void 0 : _a(d);
            if (value) {
                values.push(value);
            }
        });
    });
    return values;
};
//# sourceMappingURL=domain.js.map